export const isMobileMixin =
{
    props: {
        breakpoint: {
            type: Number,
            default: 768
        }
    },
    data() {
        return {
            windowWidth: 0
        };
    },
    computed: {
        isMobile() {
            return this.windowWidth < this.breakpoint;
        }
    },
    mounted() {
        this.windowWidth = window.innerWidth;
        window.addEventListener('resize', this.onResize);
    },
    methods: {
        onResize() {
            this.windowWidth = window.innerWidth;
        }
    }
};
